var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRugbyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1413.000000, -473.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1408.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.098375,25.5650651 C8.53922049,25.6886877 2.3595819,21.8670467 2.43779239,16.7904746 C2.51555152,11.7432004 8.78113327,7.73979299 16.325343,7.61641486 C23.8844976,7.49279232 30.0641362,11.3144333 29.9859257,16.3910054 C29.9081666,21.4382796 23.6425848,25.441687 16.098375,25.5650651 Z M16.0735991,23.9568831 C22.8817517,23.8455425 28.363768,20.3427959 28.4250432,16.3654787 C28.485867,12.4174594 23.1433267,9.11350062 16.350119,9.22459685 C9.54196644,9.33593749 4.05995011,12.8386841 3.99867492,16.8160013 C3.93785109,20.7640206 9.2803914,24.0679794 16.0735991,23.9568831 Z",
    id: "Oval",
    fillRule: "nonzero",
    transform: "translate(16.211859, 16.590740) rotate(-45.000000) translate(-16.211859, -16.590740) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7905007,6.2 L25.3515949,6.2 C25.3515949,11.2996233 11.4987081,27.1042 7.17628676,27.1042 L7.17628676,25.4958 C10.5990362,25.4958 23.7905007,10.4458313 23.7905007,6.2 Z",
    id: "Path",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRugbyWhite);
export default __webpack_public_path__ + "static/media/rugbyWhite.01c39c22ab717b073a38ad4b206111cd.svg";
export { ForwardRef as ReactComponent };